import { gql } from '@apollo/client';

export const GET_PREVIEW_ENHANCED_RACE_RESULTS = gql`
  query GetPreviewEnhancedRaceResults($date: String!, $trackName: String!) {
    previewEnhancedRaceResults(date: $date, trackName: $trackName) {
      race_id
      race_number
      race_name
      distance
      class
      race_time
      total_runners
      total_analyzed
      top_pick_roi
      value_pick_roi
      results {
        runner_id
        position
        position_finish
        position_settling
        position_800m
        position_400m
        margin
        horse_name
        jockey
        trainer
        weight
        barrier
        price_sp
        price_opening
        price_mid
        price_starting
        price_betfair
        price_nswtab
        price_victab
        prizemoney_won
        odds
        assessed_odds
        confidence
        analysis_summary
        pros
        cons
        pick_order
        pick_type
        neural_price
        neural_price_rank
        pfai_score
        pfai_price
        pfai_rank
      }
    }
  }
`;
